import { useContext } from 'react'
import { UnityContext } from '@/contexts/unity-context'

export function useUnity() {
  const unity = useContext(UnityContext)
  if (!unity) {
    throw new Error('Error!')
  }

  return {
    unity,
    metadata: unity?.details?.metadata?.metadata ?? null,
    metadataDetails: unity.details?.metadata ?? null,
    ldJson: unity?.details?.metadata?.ldJson ?? null,
    gmtId: unity?.details?.metadata?.gmtId ?? null,
    template: unity?.details?.metadata?.template ?? null,
  }
}
